:host {
  --uui-input-description-color: var(--uui-theme-variant-400);
  --uui-input-description-margin-bottom: 0.25rem;
  --uui-input-description-opacity: 1;
}

:host {
  font-family: var(--uui-primary-font-family);
  font-size: var(--uui-default-font-size);
  font-weight: var(--uui-font-weight-normal);
  line-height: var(--uui-sm-line-height);
  color: var(--uui-input-description-color);
  opacity: var(--uui-input-description-opacity);
  
}

div {
  margin-bottom: var(--uui-input-description-margin-bottom);
}
